<div
  class="cfc-common-top-panel"
  *ngIf="visible"
  [@animation]="{
    value: 'open',
    params: {
      showTransitionParams: showTransitionOptions,
      hideTransitionParams: hideTransitionOptions
    }
  }"
  [ngClass]="styleClass"
>
  <div class="cfc-common-bottom-panel-wrapper">
    <ng-content></ng-content>
  </div>
</div>
